/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './rewards/redeemed_free_processing';
import './rewards/reward_config';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLineRewards": {
                "fields": {
                  "availableRewardsBalance": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "redeemedFreeProcessing": {
                    "type": "squareup.corporate_card.resources.rewards.RedeemedFreeProcessing",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardConfig": {
                    "type": "squareup.corporate_card.resources.rewards.RewardConfig",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineRewards) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc corporate-card Rewards tied to a credit line
 * --
 *
 * SOURCE CreditLineRewards @ squareup/corporate_card/resources/credit_line_rewards.proto at 12:1
 */
export const CreditLineRewards = $root.lookupType('squareup.corporate_card.resources.CreditLineRewards');
fixType(CreditLineRewards);
Builder.createAndAttachToType(CreditLineRewards);